<template>
  <div v-if="!noResultsState" class="sorting-buttons__container q-col-12 q-col-md-6 q-col-xl-3 q-p-0 q-p-sm-1">
    <SortingButton/>
  </div>

</template>
<script setup lang="ts">
import SortingButton from "@/components/SerpPage/ResultsContainer/ButtonsContainer/SortingButton.vue";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
const serpStore = useSerpResultsStore();
const { noResultsState} = storeToRefs(serpStore)
</script>


